import React, { Component } from "react";
import axios from "axios";
import loginBackgroundImage from "../../../images/login_background_image.png";
import kpitLogo from "../../../images/kpit_logo_new.png";
import { Alert } from "react-bootstrap";
import Loader from "../../../utilityComponents/Loader";
import PropTypes from "prop-types";

class SetPassword extends Component {
    constructor() {
        super();
        this.state = {
            password: "",
            confirmPassword: "",
            oneTimePassword: "",
            username: "",
            uid: null,
            successMsg: "",
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.defaultMsgs = {
            error: "",
            inputError: "",
            successMsg: "",
        };
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    componentDidMount() {
        let params = this.getParams(window.location.href);
        this.setState((prevState) => {
            return {
                ...prevState,
                uid: params.id,
            };
        });
        console.log(this.state);
        console.log(params);
    }

    getParams(url) {
        let params = {};
        let parser = document.createElement("a");
        parser.href = url;
        let query = parser.search.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    onSubmit(e) {
        e.preventDefault();
        let validatePwd = this.validatePwdData();
        if (!validatePwd["stat"]) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    ...this.defaultMsgs,
                    inputError: validatePwd.msg,
                };
            });
        } else {
            const pwdData = {
                username: this.state.username,
                one_time_password: this.state.oneTimePassword,
                password: this.state.password
            };
            axios
                .post("/api/user/set-password/" + this.state.uid, pwdData)
                .then((response) => {
                    console.log(response);
                      this.setState((prevState) => {
                            return {
                                password: "",
                                confirmPassword: "",
                                oneTimePassword: "",
                                username: "",
                                uid: null,
                                ...this.defaultMsgs,
                                successMsg: 'Password Updated!!',
                            };
                        });
                })
                .catch((error) => {
                    console.log(error);
                    const data = error.response.data;
                    if (
                        Object.prototype.hasOwnProperty.call(error, "response") &&
                        Object.prototype.hasOwnProperty.call(error.response, "data") &&
                        Object.prototype.hasOwnProperty.call(error.response.data, "message")
                    ) {
                        const data = error.response.data;
                        this.setState((prevState) => {
                            return {
                                ...prevState,
                                ...this.defaultMsgs,
                                error: data.message,
                            };
                        });
                    } else {
                        this.setState((prevState) => {
                            return {
                                ...prevState,
                                ...this.defaultMsgs,
                                error: "Something Went Wrong, Please Try Again!!",
                            };
                        });
                    }
                });
        }
    }
    _redirectToLogin(){
        this.props.history.push(`/`);
    }
    validatePwdData() {
        if (!this.state.oneTimePassword) {
            return {
                stat: false,
                msg: "Please enter OTP",
            };
        }else if (!this.state.password) {
            return {
                stat: false,
                msg: "Please enter password",
            };
        } else if (
            !this.state.confirmPassword ||
            this.state.password != this.state.confirmPassword
        ) {
            return {
                stat: false,
                msg: "Password not matching",
            };
        } else {
            return {
                stat: true,
                pwd: "Password matching",
            };
        }
    }

    render() {
        return (
            <div className="row" style={{ backgroundColor: "white" }}>
                <div className="col-6" style={{ padding: "0px" }}>
                    <img src={loginBackgroundImage} alt="" style={{ width: "100%" }}></img>
                </div>
                <div className="col-6">
                    <div className="row" style={{ paddingTop: "8%" }}>
                        <div className="col-8"></div>
                        <div className="col-3">
                            <img src={kpitLogo} alt="" style={{ width: "75%" }}></img>
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: "4%" }}>
                        <div className="col-3"></div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-12">
                                    <h2>New Password</h2>
                                    <br />
                                    <div style={{ textAlign: "left", fontSize: "14px" }}>
                                        Password must contain:
                                        <li>Min. 8 letters</li>
                                        <li>Min. 1 uppercase letter</li>
                                        <li>Min. 2 numbers</li>
                                        <li>Min. 1 special character</li>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {this.state.error && (
                                        <Alert variant="danger">
                                            <Alert.Heading>Got an error!</Alert.Heading>
                                            <p>{this.state.error}</p>
                                        </Alert>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {this.state.inputError && (
                                        <Alert variant="warning">
                                            <Alert.Heading>Got an error!</Alert.Heading>
                                            <p>{this.state.inputError}</p>
                                        </Alert>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {this.state.successMsg && (
                                        <Alert variant="success">
                                            <Alert.Heading>{this.state.successMsg}</Alert.Heading>
                                            <p><a onClick={ () => this._redirectToLogin()}>Click here to Login</a></p>
                                        </Alert>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {this.state.loading ? (
                                        <Loader />
                                    ) : (
                                        <form validate="true" onSubmit={this.onSubmit}>
                                            <div data-testid="usernameInput" className="form-group">
                                                <label
                                                    htmlFor="username"
                                                    className="card-title"
                                                    style={{
                                                        color: "#464646",
                                                        fontSize: "100% !important",
                                                    }}
                                                >
                                                    <b>Username:</b>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="username"
                                                    placeholder="Username"
                                                    value={this.state.username}
                                                    onChange={this.onChange}
                                                    required
                                                />
                                            </div>
                                            <div data-testid="oneTimePasswordInput" className="form-group">
                                                <label
                                                    htmlFor="oneTimePassword"
                                                    className="card-title"
                                                    style={{
                                                        color: "#464646",
                                                        fontSize: "100% !important",
                                                    }}
                                                >
                                                    <b>One time password:</b>
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="oneTimePassword"
                                                    placeholder="One time password"
                                                    value={this.state.oneTimePassword}
                                                    onChange={this.onChange}
                                                    required
                                                />
                                            </div><div data-testid="passwordInput" className="form-group">
                                                <label
                                                    htmlFor="email"
                                                    className="card-title"
                                                    style={{
                                                        color: "#464646",
                                                        fontSize: "100% !important",
                                                    }}
                                                >
                                                    <b>Password:</b>
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="password"
                                                    placeholder="Password"
                                                    value={this.state.password}
                                                    onChange={this.onChange}
                                                    required
                                                />
                                            </div>
                                            <div
                                                data-testid="confirmPasswordInput"
                                                className="form-group"
                                            >
                                                <label
                                                    htmlFor="confirmPassword"
                                                    className="card-title"
                                                    style={{
                                                        color: "#464646",
                                                        fontSize: "100% !important",
                                                    }}
                                                >
                                                    <b>Confirm Password:</b>
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="confirmPassword"
                                                    placeholder="Password"
                                                    value={this.state.confirmPassword}
                                                    onChange={this.onChange}
                                                    required
                                                />
                                            </div>
                                            <button
                                                type="submit"
                                                className="btn btn-lg btn-block"
                                                style={{
                                                    backgroundColor: "#858AFF",
                                                    color: "#FFFFFF",
                                                }}
                                            >
                                                Submit
                                            </button>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SetPassword.propTypes = {
    history: PropTypes.string,
};

SetPassword.defaultProps = {
    history: [],
};

export default SetPassword;
